<template>
  <div class="path-map" style="width: 940px; height: 600px">
    <div id="map" style="width: 940px; height: 600px"></div>
  </div>
</template>
<script>
export default {
  props: {
    points: {
      defaultValue: [],
      type: Array,
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      /* eslint-disable */
      mapboxgl.accessToken =
        "pk.eyJ1IjoiYmdnenMiLCJhIjoiY2tzcjUyeGtpMGpoOTJxdGZtNDhxN3VodiJ9.UQVHE5qeEUAQ0_GDuLzqiw";
      var map = new mapboxgl.Map({
        container: "map", // container id
        style: {
          version: 8,

          sources: {
            "vec_w-tiles": {
              type: "raster",
              tiles: [
                "https://t0.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=d515aa7fac4a9daa7b2b1fff46a2d3d0",
              ],
              tileSize: 256,
            },
            "cva_w-tiles": {
              type: "raster",
              tiles: [
                "https://t0.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=d515aa7fac4a9daa7b2b1fff46a2d3d0",
              ],
              tileSize: 256,
            },
          },
          layers: [
            {
              id: "vec_w-tiles",
              type: "raster",
              source: "vec_w-tiles",
              minzoom: 0,
              maxzoom: 22,
            },

            {
              id: "cva_w-tiles",
              type: "raster",
              source: "cva_w-tiles",
              minzoom: 0,
              maxzoom: 22,
            },
          ],
        },
        center: [120, 28], // starting position
        zoom: 22, // starting zoom
        minZoom: 1,
        maxZoom: 24,
        // dragRotate: false,
      });
      var canvas = map.getCanvas();
      // 设置地图画布的固定宽度和高度
      canvas.style.width = "100%"; // 设置宽度
      canvas.style.height = "600px"; // 设置高度
      document.getElementById("map").style.width = "100%"; // 设置宽度
      document.getElementById("map").style.height = "600px";
      this.points.forEach(function (point) {
        var marker = new mapboxgl.Marker()
          .setLngLat([point.longitude, point.latitude]) // 设置点位的经纬度坐标
          .addTo(map);

        // 定义弹出窗口内容
        var popup = new mapboxgl.Popup({ offset: 25 }).setHTML(
          '<img src="' + point.thumbnail + '" />'
        ); // 在弹出窗口中显示对应的图片

       
        // 点击点位时显示弹出窗口
        marker.setPopup(popup);
      });
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
</style>